import React from "react";
import { FormattedMessage } from "react-intl";
const ContactHoursOfOperation = () => (<div className="vr vr_x5">
		<h2 className="hdg hdg_subtle vr vr_x1">
			<FormattedMessage id="contact.public.hours.heading" defaultMessage="Hours of Operation"/>
		</h2>

		<ul>
			<li className="text">
				<FormattedMessage tagName="p" id="contact.public.hours.line1" defaultMessage="Monday – Thursday, 7:00am – 7:00pm (CT)"/>
			</li>
			<li className="text">
				<FormattedMessage tagName="p" id="contact.public.hours.line2" defaultMessage="Friday, 7:00am – 5:00pm (CT)"/>
			</li>
		</ul>
	</div>);
export default ContactHoursOfOperation;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/ContactHoursOfOperation/ContactHoursOfOperation.tsx